import type { ComponentType } from 'react'
import {
  IconCheckCircle,
  IconCloseCircle,
  IconInfoCircle,
  IconWarning,
} from '@/app/components/atoms/Icons'
import type { IconProps } from '@/app/components/atoms/Icons'
import type { ToastVariant } from './types'

/** Componente de icono de estado por cada variante (reutiliza `atoms/Icons`). */
export const TOAST_STATUS_ICONS: Readonly<
  Record<ToastVariant, ComponentType<IconProps>>
> = {
  success: IconCheckCircle,
  error: IconCloseCircle,
  info: IconInfoCircle,
  warning: IconWarning,
}

/**
 * Texto que precede al mensaje para lectores de pantalla. Garantiza que el
 * estado se comunique también de forma textual (no solo por color/icono).
 */
export const TOAST_STATUS_LABELS: Readonly<Record<ToastVariant, string>> = {
  success: 'Éxito',
  error: 'Error',
  info: 'Información',
  warning: 'Advertencia',
}

/** Etiqueta accesible del botón de cierre. */
export const TOAST_CLOSE_LABEL = 'Cerrar notificación'

/** Variante por defecto cuando no se especifica. */
export const TOAST_DEFAULT_VARIANT: ToastVariant = 'info'
